/**
 * SHIELD CHANCES — the moments in a game when a Shield can be won. Never
 * handed out by the Host: every guest decides on their own phone, and the
 * game moves on by itself once they have.
 *
 *   temptation  SECRET. Everyone chooses privately whether to reach for it.
 *               Every hand that reaches takes gold from the pot; one of them
 *               wins the Shield. The TV shows how many reached, never who.
 *   one-hand    PUBLIC. Everyone sees who claims it. Exactly one claim: the
 *               Shield is theirs. Two or more: it shatters. None: it's lost.
 *   bargain     SECRET. One guest, chosen at random, is offered the Shield
 *               for a slice of the pot. Only they know it was them.
 *
 * A Shield saves its holder from one murder. Several guests can hold one at
 * once. An Unfaithful can win one too: it can't save them (they're never
 * murdered), but it makes a fine alibi.
 */
export const SHIELD_KINDS = ["temptation", "one-hand", "bargain"];
export const SHIELD_INFO = {
    temptation: {
        title: "The Temptation",
        open: false,
        brief: "A Shield lies in the chest. Reach in, and it may be yours. But every hand that reaches takes gold from the pot.",
        question: "Reach for the Shield? Every hand that reaches costs the pot {cost}. One of you will win it.",
        take: "Reach in",
        leave: "Leave the gold",
    },
    "one-hand": {
        title: "One Hand",
        open: true,
        brief: "One Shield. Claim it in front of everyone. If one of you claims it, it's yours. If two of you reach for it, it shatters.",
        question: "Claim the Shield? Everyone will see. If anyone else claims it too, nobody gets it.",
        take: "Claim it",
        leave: "Hold back",
    },
    bargain: {
        title: "The Bargain",
        open: false,
        brief: "One of you is being offered a Shield, right now, in secret. The price comes out of the pot.",
        question: "The Shield is yours, for {cost} from the pot. Nobody will know it was you.",
        take: "Take the deal",
        leave: "Refuse",
    },
};
/** What a hand in the chest costs the pot (Temptation), and the price of the Bargain. */
export const SHIELD_COST = { temptation: 2_000, bargain: 6_000 };
/** How many Shield chances a game of this size gets. */
export function shieldChancesFor(players) {
    if (players <= 7)
        return 1;
    if (players <= 11)
        return 2;
    return 3;
}
/** The latest mission a chance can follow, so they come while the game is still young enough to matter. */
export function lastShieldMission(players) {
    return Math.max(2, Math.floor(players / 2) - 1);
}
//# sourceMappingURL=shields.js.map